import React, { useRef } from "react";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import { useTranslation } from "react-i18next";

import useLoadingStore from "../../store/useLoadingStore";
import useModalStore from "../../store/useModalStore";
import LoadingIcon from "./LoadingIcon";
import ModalStartApply from "../modal/ModalStartApply";
import ModalConfirm from "../modal/ModalConfirm";
import ModalInfo from "../modal/ModalInfo";

const LoadingOverlay = ({ children }) => {
    const { t } = useTranslation();
    const { isLoading } = useLoadingStore();
    const { isSmallModalOpen, closeSmallModal } = useModalStore();
    const nodeRef = useRef(null);

    return (
        <>
            <CSSTransition
                nodeRef={nodeRef}
                in={isLoading}
                timeout={250}
                classNames="fade"
                unmountOnExit
            >
                <Overlay ref={nodeRef}>
                    <LoadingIcon>{t("loading")}...</LoadingIcon>
                </Overlay>
            </CSSTransition>

            <ModalInfo />
            <ModalConfirm />
            <ModalStartApply />

            {children}
        </>
    );
};

const Overlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0px;
  left: 0px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 1.2em;
  color: var(--aia-bx-white);
  background: rgba(0, 0, 0, 0.3);
  z-index: 2000;
`;
export default LoadingOverlay;